import React from "react";
import TextLink from "@streeteasy/design-system/deprecated/TextLink";
import Title from "@streeteasy/design-system/deprecated/Title";
import { string } from "prop-types";

import { tooltipBlogLink, tooltipHeader, tooltipText } from "./constants";
import * as S from "./styled";

const NetEffectiveRentTooltip = ({ contentPosition }) => (
  <S.TooltipWrapper
    hasCloseButton
    position={contentPosition}
    trigger="click"
    width={window.innerWidth <= 450 ? "260px" : "302px"}
    zIndex={999}
  >
    <Title type="secondarySmCaps">{tooltipHeader}</Title>
    <S.TooltipText type="sm">{tooltipText}</S.TooltipText>
    <TextLink href={tooltipBlogLink} target="_blank">
      Learn more
    </TextLink>
  </S.TooltipWrapper>
);

NetEffectiveRentTooltip.propTypes = {
  contentPosition: string.isRequired
};

export default NetEffectiveRentTooltip;
